import { createStore } from "vuex";
import { login,submitAppInfo,submitAppInfo2 } from '@api/index.js'
import { setToken, setTokenFromStorage, removeToken, removeTokenFromStorage, setPhone,setPhoneFromStorage} from '../utils/tool'

 const store = createStore({
    state () {
        return {
            token : '',
            toast_state: false,
            toast_txt: '',
            phone: "",
            isApp:false
        }
    },
    getters: {
        token (state) {
            return state.token
        },
        toast_txt (state) {
            return state.toast_txt
        }
    },
    mutations: {
        setToken(state, token) {
            state.token = token
        },
        setToast(state, show) {
            state.toast_state = show
        },
        setToastTxt(state, txt) {
            state.toast_txt = txt
        },
        setApp(state, isApp) {
            state.isApp = isApp
        },
        clearToken(state) {
            state.token = ''
            removeToken()
            removeTokenFromStorage()
        },
        setPhone(state, phone) {
            state.phone = phone
            setPhone(phone)
        }
    },
    actions: {
        closeToast({ commit }) {
            commit('setToast', false)
        },
        showToast({ commit }) {
            commit('setToast', true)
        },
        setToastTxt({ commit }, txt) {
            commit('setToastTxt', txt)
        },
        clearToken({ commit }) {
            commit('clearToken')
        },        
        setToken( { commit }, token ) {
            commit('setToken', token)                    
            setToken(token)
            setTokenFromStorage(token)
        },
        customLogin2({ commit }, appInfo) {
            return new Promise((resolve, reject) => {
                submitAppInfo2(appInfo.params, appInfo.customHeader).then(response => {
                  if(response.code == 0 ){
                      const { token } = response.data
                      commit('setToken', token)
                      commit('setApp', true)
                      setToken(token)
                      setTokenFromStorage(token)
                      resolve()
                      
                  } else {
                      reject(response.msg)    
                  }   
                }).catch(error => {
                  reject(error)
                })
              })
        },
        customLogin({ commit }, appInfo) {
            return new Promise((resolve, reject) => {
                submitAppInfo(appInfo.params, appInfo.customHeader).then(response => {
                  if(response.code == 0 ){
                      const { token } = response.data
                      commit('setToken', token)
                      commit('setApp', true)
                      setToken(token)
                      setTokenFromStorage(token)
                      
                  } else {
                      reject(response.msg)    
                  }   
                }).catch(error => {
                  reject(error)
                })
              })
        },
        login({ commit }, userInfo) {            
            const { phone, code } = userInfo
            return new Promise((resolve, reject) => {
              login({ phone: '91'+phone.trim(), code: code }).then(response => {
                if(response.code == 0 ){
                    const { token } = response.data
                    commit('setToken', token)
                    commit('setPhone', phone)
                    commit('setApp', false)
                    setToken(token)
                    setPhone(phone)
                    setTokenFromStorage(token)
                    setPhoneFromStorage(phone)
                    resolve({
                        isRegister:response.data.isRegister
                    })
                } else {
                    reject(response.msg)    
                }   
              }).catch(error => {
                reject(error)
              })
            })
          },
    }
})
export default store